import { Component } from "react"
import PropTypes from "prop-types"
import LineTarget from "components/charts/line-target"
import LoadingWrapper from "components/loading-wrapper"
import OptimizationLoading from "components/material/loading"
import OptimizationError from "components/material/error"
import TooltipContent from "./components/tooltip-content"
import "./style.scss"

class OptimizationScanner extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    dots: PropTypes.array.isRequired,
    setRiskTarget: PropTypes.func.isRequired,
    optimizationScanner: PropTypes.func.isRequired,
    riskTargetPoint: PropTypes.object,
    status: PropTypes.string,
    selectedCustomForecast: PropTypes.string,
  }

  componentDidMount() {
    this.props.optimizationScanner()
  }

  render() {
    const { data, setRiskTarget, riskTargetPoint, status, dots, selectedCustomForecast } = this.props
    const loadingComponent = <OptimizationLoading />
    const errorComponent = <OptimizationError text="There was an error while loading the efficient frontier. Please try again." />

    return <div className="modules_optimization-scanner">
      <LoadingWrapper status={[status]} loadingComponent={loadingComponent} errorComponent={errorComponent}>
        <div className="optimization-card">
          <LineTarget
            setSelectedData={setRiskTarget}
            data={data}
            height={342}
            dots={dots}
            target={riskTargetPoint}
            xAxisLabel="Predicted Total Risk (%)"
            yAxisLabel={selectedCustomForecast ? "Forecasted Expected Return (%)" : "Implied Expected Return (%)"}
            highlighterLabel="Risk Target"
            TooltipContent={TooltipContent}
          />
        </div>
      </LoadingWrapper>
    </div>
  }
}

export default OptimizationScanner
